import * as Yup from 'yup';

export const formSchema = Yup.object().shape({
    name: Yup.string().min(3, 'Wartość nie może być krótsza niż 3 znaki').required('Pole obowiązkowe'),
    surname: Yup.string().min(3, 'Wartość nie może być krótsza niż 3 znaki').required('Pole obowiązkowe'),
    email: Yup.string().email('Niepoprawny format').required('Pole obowiązkowe'),
    university: Yup.string().required('Pole obowiązkowe'),
    status: Yup.string().required('Pole obowiązkowe'),
    rules:  Yup.bool().required('Zaakceptuj regulamin'),
    statement: Yup.bool().required('Zaakceptuj oświadczenie'),
})
